import { ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core'
import { ModalHeaderComponent } from '../modal-header/modal-header.component'
import { ModalFooterComponent } from '../modal-footer/modal-footer.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalBodyComponent } from '../modal-body/modal-body.component'
import { firstValueFrom, Subscription, switchMap, take, tap } from 'rxjs'
import { SpinnerComponent } from '../../spinner/spinner.component'
import { FilterService } from 'src/app/shared/services/filter/filter.service'
import { ActiveFilterListComponent } from '../../table/filters/active-filter-list/active-filter-list.component'
import { ServicePointManagementService } from '../../service-point-management/service-point-management.service'

@Component({
  imports: [
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    ActiveFilterListComponent,
    SpinnerComponent,
  ],
  selector: 'app-export-service-point-flags-modal',
  styles: `
    div.loading {
      margin-top: 3rem;
    }

    .spinner-anchor {
      position: absolute;
      left: 50%;
      top: -3rem;
    }

    .warn {
      color: goldenrod;
    }

    .error {
      color: red
    }
  `,
  template: `
    <div app-modal-header>Export Service Point Flags</div>
    <div app-modal-body [class.loading]="loading">
      @if(loading) {
      <span class="spinner-anchor">
        &nbsp;
        <app-spinner></app-spinner>
      </span>
      } @else {
        <app-active-filter-list [filterGroup]="filterGroup" [filterName]="filtersToShow"></app-active-filter-list>
      }
      <span class="warn"
        >If you are exporting a large data set, it could take some time. Please
        be patient and do not refresh the page until the data has been
        downloaded</span
      >
    </div>
    <div app-modal-footer>
      <button class="action-btn" (click)="onCancel()">Cancel</button>
      <button
        class="action-btn primary"
        (click)="onDownload()"
        [disabled]="loading"
      >
        Download
      </button>
    </div>
  `,
})
export class ExportServicePointFlagsModalComponent implements OnDestroy {
  activeModal = inject(NgbActiveModal)
  filterService = inject(FilterService)
  changeDetectorRef = inject(ChangeDetectorRef)
  servicePointManagementService = inject(ServicePointManagementService)

  loading = false
  filterGroup: string
  filtersToShow: string[]

  subscription = new Subscription()

  init(filterGroup: string, filtersToShow: string[]) {
    this.filterGroup = filterGroup
    this.filtersToShow = filtersToShow
  }

  async onDownload() {
    await firstValueFrom(this.filterService
      .asParams(this.filterGroup)
      .pipe(
        take(1),
        switchMap((params) => {
          return this.servicePointManagementService
            .exportFlags(params.filter(p => this.filtersToShow.includes(p.name)))
        }),
        tap(() => this.activeModal.dismiss()),
      ))
  }

  onCancel() {
    this.activeModal.dismiss()
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
